import Avatar from "@components/avatar";
import Select from "react-select";
import { selectThemeColors } from "@utils";
import { getBrandDashboardStatsValues } from "@store/actions/brandsDashboard";
import * as ICON from "react-feather";
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Col,
  Media,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const FilterByOptions = [
  { value: "all", label: "All" },
  { value: "month", label: "Month" },
  { value: "quarter", label: "Quarter" },
  { value: "year", label: "Year" },
];

const DashboardStats = () => {
  const dispatch = useDispatch();
  const { brandStatsLoading, brandStatsFullFill, brandStatsError } =
    useSelector((state) => state.brandsDashboardSlice);

  useEffect(() => {
    dispatch(getBrandDashboardStatsValues("all"));
  }, []);

  const filterStats = (filterValue) => {
    dispatch(getBrandDashboardStatsValues(filterValue));
  };
  return (
    <Card>
      <CardHeader>
        <CardTitle>Statistics</CardTitle>
        <Select
          theme={selectThemeColors}
          className="react-select w-250px"
          classNamePrefix="select"
          defaultValue={FilterByOptions[0]}
          options={FilterByOptions}
          isClearable={false}
          isSearchable={false}
          onChange={(e) => filterStats(e.value)}
        />
      </CardHeader>
      <CardBody>
        <Row>
          <Col sm={12} md={4} lg={4} className="mb-2">
            <Media>
              <Avatar
                color="light-primary"
                icon={<ICON.User size={21} />}
                className="mr-1"
                id="my-rds"
              />
              <Media className="media-avatar m-auto" body={true}>
                <h4 className="font-weight-bolder mb-0">
                  {brandStatsLoading ? "..." : brandStatsFullFill?.data?.my_rds}
                </h4>
                <h6 className="total-partnership">My RDs</h6>
              </Media>
            </Media>
          </Col>

          <Col sm={12} md={4} lg={4} className="mb-2">
            <Media>
              <Avatar
                color="light-warning"
                icon={<ICON.TrendingUp size={21} />}
                className="mr-1"
                id="consumer-impact"
              />
              <Media className="media-avatar m-auto" body={true}>
                <h4 className="font-weight-bolder mb-0">
                  {brandStatsLoading
                    ? "..."
                    : brandStatsFullFill?.data?.consumer_impact}
                </h4>
                <h6 className="total-partnership">Consumer Impact</h6>
              </Media>
            </Media>
          </Col>

          <Col sm={12} md={4} lg={4} className="mb-2">
            <Media>
              <Avatar
                color="light-info"
                icon={<ICON.Gift size={21} />}
                className="mr-1"
                id="my-partnerships"
              />
              <Media className="media-avatar m-auto" body={true}>
                <h4 className="font-weight-bolder mb-0">
                  {brandStatsLoading
                    ? "..."
                    : brandStatsFullFill?.data?.my_partnerships}
                </h4>
                <h6 className="total-partnership">My Partnerships</h6>
              </Media>
            </Media>
          </Col>

          <Col sm={12} md={4} lg={4} className="mb-2">
            <Media>
              <Avatar
                color="light-danger"
                icon={<ICON.Box size={21} />}
                className="mr-1"
                id="samples-shared"
              />
              <Media className="media-avatar m-auto" body={true}>
                <h4 className="font-weight-bolder mb-0">
                  {brandStatsLoading
                    ? "..."
                    : brandStatsFullFill?.data?.samples_shared}
                </h4>
                <h6 className="total-partnership">Samples Shared</h6>
              </Media>
            </Media>
          </Col>

          <Col sm={12} md={4} lg={4} className="mb-2">
            <Media>
              <Avatar
                color="light-dark"
                icon={<ICON.Users size={21} />}
                className="mr-1"
                id="samples-shared"
              />
              <Media className="media-avatar m-auto" body={true}>
                <h4 className="font-weight-bolder mb-0">
                  {brandStatsLoading
                    ? "..."
                    : brandStatsFullFill?.data?.all_rds}
                </h4>
                <h6 className="total-partnership">All RDs</h6>
              </Media>
            </Media>
          </Col>

          <Col sm={12} md={4} lg={4} className="mb-2">
            <Media>
              <Avatar
                color="light-success"
                icon={<ICON.DollarSign size={21} />}
                className="mr-1"
                id="total-investment"
              />
              <Media className="media-avatar m-auto" body={true}>
                <h4 className="font-weight-bolder mb-0">
                  {brandStatsLoading
                    ? "..."
                    : brandStatsFullFill?.data?.total_investment}
                </h4>
                <h6 className="total-partnership">Total Investment</h6>
              </Media>
            </Media>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default DashboardStats;
